import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    flexDirection: 'column',
    gap: 5,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
  },
  mainSection: {
    flexDirection: 'column',
    gap: 20,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 20,
  },
  input: {
    borderRadius: 10,
    width: '100%',
    height: 40,
    paddingHorizontal: 10,
    padding: 0,
    borderWidth: 1,
  },
  bottomButton: {
    width: '100%',
    alignSelf: 'center',
    borderRadius: 50,
  },
  orderIdLeftComp: {
    marginRight: -12,
  },
  phoneNumberLeftComp: {
    marginRight: -10,
  },
  header: {
    textAlign: 'left',
    marginBottom: 5,
  },
  subTitle: {
    textAlign: 'left',
    lineHeight: 20,
  },
});
